import { apiURL } from "./Base";
import "whatwg-fetch";

const leadID = 9;

const jsonPipe = response => response.json();

const usingLeadsAPI = {
  isAlreadyExists: (body, callback) => {
    let data = fetch(`${apiURL}IsExists`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(
        Object.assign(
          {
            leadID: leadID
          },
          body
        )
      )
    }).then(jsonPipe);

    return callback ? data.then(res => callback(res)) : data;
  },
  saveResults: (body, callback) => {
    let data = fetch(`${apiURL}Save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(
        Object.assign(
          {
            leadID: leadID
          },
          body
        )
      )
    }).then(jsonPipe);

    return callback ? data.then(res => callback(res)) : data;
  }
};

export { usingLeadsAPI, leadID };



// WEBPACK FOOTER //
// ./src/Components/Services/fetchService.js